// extracted by mini-css-extract-plugin
module.exports = {"regularEmoji":"_1vSllU8EiluIfF-b64aaLL","jumboEmoji":"Bd7UAY8xV3CWQZpt2JBE-"};